import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Button, Link, MenuItem, Tooltip } from "@mui/material";
import { contextMenuClasses, StyledMenu } from "./simpleTableStyles";

const ServerRowMenu = ({ clickedRow, contextMenuItems, onClose }) => {
  const handleClickItem = useCallback(
    (menuItem) => {
      menuItem.onClick(clickedRow);
      onClose();
    },
    [contextMenuItems, onClose]
  );

  const anchorEl = clickedRow?.event?.target.closest(".MuiDataGrid-cell");
  return (
    <StyledMenu
      id="context-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(clickedRow)}
      onClose={onClose}
      disableScrollLock={true}
    >
      {contextMenuItems &&
        contextMenuItems.map((menuItem, idx) => {
          if (menuItem.link) {
            return (
              <MenuItem
                key={idx}
                className={contextMenuClasses.linkLi}
                datacy={menuItem.datacy}
              >
                <Link
                  to={menuItem.link}
                  target={"_blank"}
                  onClick={() => handleClickItem(menuItem)}
                >
                  {menuItem.text}
                </Link>
              </MenuItem>
            );
          } else if (menuItem.isDisabled) {
            return (
              <Tooltip
                key={idx}
                title={menuItem.disabledTooltip}
                placement={"left"}
                classes={{ tooltip: contextMenuClasses.tooltip }}
              >
                <MenuItem
                  datacy={menuItem.datacy}
                  className={contextMenuClasses.disabledMenuItem}
                >
                  {menuItem.text}
                </MenuItem>
              </Tooltip>
            );
          } else {
            return (
              <MenuItem
                key={idx}
                datacy={menuItem.datacy}
                className={contextMenuClasses.buttonLi}
                onClick={() => handleClickItem(menuItem)}
              >
                <Button fullWidth className={contextMenuClasses.menuItemButton}>
                  {menuItem.text}
                </Button>
              </MenuItem>
            );
          }
        })}
    </StyledMenu>
  );
};

ServerRowMenu.propTypes = {
  clickedRow: PropTypes.object,
  contextMenuItems: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func.isRequired,
};

export default ServerRowMenu;
